import React from "react"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AITrainingDetail } from "../../../Components/Views/Dashboard/Sections/AppDetail/AIModels/Training/AITrainingDetail"
import { AppDetailRouteComponentProps } from "../../RouteProps"

export function AppTrainingInstanceDetailRoute({
    match
}: AppDetailRouteComponentProps<{
    instanceID: string
}>) {
    return (
        <AppAuthCheck {...match.params} scope="ai-training:view">
            <AITrainingDetail {...match.params} />
        </AppAuthCheck>
    )
}
